import React from 'react';
import { TenantDashboard as TenantDashboardComponent } from '@/components/tenant/TenantDashboard';

const TenantDashboard: React.FC = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8">
        <TenantDashboardComponent />
      </div>
    </div>
  );
};

export default TenantDashboard;